export const paymentMethodsFrame = [
  {
    label: "Todos",
    value: "ALL",
  },
  {
    label: "ONLINE",
    value: "ONLINE",
  },
  {
    label: "DINHEIRO",
    value: "DINHEIRO",
  },
  {
    label: "MAQUININHA",
    value: "MAQUININHA",
  },
  {
    label: "VALE FUNCIONÁRIO",
    value: "VALE_FUNCIONÁRIO",
  },
  {
    label: "VALE EXTERNO",
    value: "VALE_OUTSIDER",
  },
];

export const platformsFrame = [
  {
    label: "Todas",
    value: "ALL",
  },
  {
    label: "iFood",
    value: "IFOOD",
  },
  {
    label: "Delivery Direto",
    value: "DELIVERY_DIRETO",
  },
  {
    label: "Neemo",
    value: "NEEMO",
  },
  {
    label: "99Food",
    value: "FOOD99",
  },
  {
    label: "Americanas",
    value: "AMERICANAS_DELIVERY",
  },
  {
    label: "PDV / SALAO",
    value: "SLAPIE_POS",
  },
];

export const orderTypesFrame = [
  {
    label: "Todas",
    value: "ALL",
  },
  {
    label: "Retirada",
    value: "TAKEOUT",
  },
  {
    label: "Entrega",
    value: "DELIVERY",
  },
];

export const orderStatusFrame = [
  {
    label: "Todos",
    value: "ALL",
  },
  {
    label: "Aguardando Aprovação",
    value: "Aguardando Aprovação",
  },
  {
    label: "Confirmação enviada",
    value: "Confirmação enviada",
  },
  {
    label: "Confirmado",
    value: "Confirmado",
  },
  {
    label: "Aguardando confirmação de despache",
    value: "Aguardando confirmação de despache",
  },
  {
    label: "A caminho",
    value: "A caminho",
  },
  {
    label: "Em preparo",
    value: "Em preparo",
  },
  {
    label: "Aguardando confirmação de Pronto",
    value: "Aguardando confirmação de Pronto",
  },
  {
    label: "Pronto para retirada",
    value: "Pronto para retirada",
  },
  {
    label: "Finalizado",
    value: "Finalizado",
  },
  {
    label: "Cancelamento Solicitado",
    value: "Cancelamento Solicitado",
  },
  {
    label: "Aguardando cancelamento",
    value: "Aguardando cancelamento",
  },
  {
    label: "Aguardando cancelamento aceito",
    value: "Aguardando cancelamento aceito",
  },
  {
    label: "Aguardando cancelamento rejeitado",
    value: "Aguardando cancelamento rejeitado",
  },
  {
    label: "Cancelado",
    value: "Cancelado",
  },
];

export const orderCancelReasonsFrame = [
  {
    cancelCodeId: 501,
    description: "PROBLEMAS DE SISTEMA\n",
  },
  {
    cancelCodeId: 502,
    description: "PEDIDO EM DUPLICIDADE\n",
  },
  {
    cancelCodeId: 503,
    description: "ITEM INDISPONÍVEL\n",
  },
  {
    cancelCodeId: 504,
    description: "RESTAURANTE SEM MOTOBOY\n",
  },
  {
    cancelCodeId: 505,
    description: "CARDÁPIO DESATUALIZADO\n",
  },
  {
    cancelCodeId: 506,
    description: "PEDIDO FORA DA ÁREA DE ENTREGA\n",
  },
  {
    cancelCodeId: 507,
    description: "CLIENTE GOLPISTA / TROTE\n",
  },
  {
    cancelCodeId: 508,
    description: "FORA DO HORÁRIO DO DELIVERY\n",
  },
  {
    cancelCodeId: 509,
    description: "DIFICULDADES INTERNAS DO RESTAURANTE\n",
  },
  {
    cancelCodeId: 511,
    description: "ÁREA DE RISCO\n",
  },
  {
    cancelCodeId: 512,
    description: "RESTAURANTE ABRIRÁ MAIS TARDE\n",
  },
];

export const orderStatusNumberFrame = [
  {
    label: "Todos",
    value: "ALL",
  },
  {
    label: "Aguardando Aprovação",
    value: 0,
  },
  {
    label: "Confirmação enviada",
    value: 1,
  },
  {
    label: "Confirmado",
    value: 2,
  },
  {
    label: "Aguardando confirmação de despache",
    value: 3,
  },
  {
    label: "A caminho",
    value: 5,
  },
  {
    label: "Em preparo",
    value: 8,
  },
  {
    label: "Aguardando confirmação de Pronto",
    value: 13,
  },
  {
    label: "Pronto para retirada",
    value: 21,
  },
  {
    label: "Aguardando Confirmação de Conclusão",
    value: 27,
  },
  {
    label: "Finalizado",
    value: 34,
  },
  {
    label: "Cancelamento Solicitado",
    value: 55,
  },
  {
    label: "Aguardando cancelamento",
    value: 89,
  },
  {
    label: "Aguardando cancelamento aceito",
    value: 144,
  },
  {
    label: "Aguardando cancelamento rejeitado",
    value: 233,
  },
  {
    label: "Cancelado",
    value: 377,
  },
];

export const fiscalTicketTypeFrame = [
  { label: "NFC-e", value: 2 },
  { label: "NF-e", value: 3 },
];

export const stateInscriptionIndicatorFrame = [
  { label: "Contribuinte ICMS", value: 1 },
  {
    label:
      "Contribuinte isento de Inscrição no cadastro de Contribuintes do ICMS",
    value: 2,
  },
  {
    label:
      "Não Contribuinte, que pode ou não possuir Inscrição Estadual no Cadastro de Contribuintes do ICMS",
    value: 9,
  },
];

export const taxRegimeFrame = [
  { label: "Simples Nacional", value: "1" },
  {
    label: "Simples Nacional - Excesso de sublimite de receita bruta",
    value: "2",
  },
  { label: "Regime Normal", value: "3" },
];

export const cfopFrame = [
  // VENDAS DENTRO DO ESTADO (5.000)
  { label: "5101 - Venda de produção do estabelecimento", value: "5101" },
  {
    label: "5102 - Venda de mercadoria adquirida ou recebida de terceiros",
    value: "5102",
  },
  {
    label:
      "5103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento",
    value: "5103",
  },
  {
    label:
      "5104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento",
    value: "5104",
  },
  {
    label:
      "5109 - Venda de produção do estabelecimento, não tributada pelo ICMS",
    value: "5109",
  },
  {
    label:
      "5110 - Venda de mercadoria adquirida ou recebida de terceiros, não tributada pelo ICMS",
    value: "5110",
  },
  {
    label:
      "5111 - Venda de produção do estabelecimento remetida anteriormente em consignação industrial",
    value: "5111",
  },
  {
    label:
      "5112 - Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação industrial",
    value: "5112",
  },
  {
    label:
      "5113 - Venda de produção do estabelecimento remetida anteriormente em consignação mercantil",
    value: "5113",
  },
  {
    label:
      "5114 - Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação mercantil",
    value: "5114",
  },
  {
    label:
      "5115 - Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil",
    value: "5115",
  },
  {
    label:
      "5116 - Venda de produção do estabelecimento originada de encomenda para entrega futura",
    value: "5116",
  },
  {
    label:
      "5117 - Venda de mercadoria adquirida ou recebida de terceiros, originada de encomenda para entrega futura",
    value: "5117",
  },
  {
    label:
      "5118 - Venda de produção do estabelecimento entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem",
    value: "5118",
  },
  {
    label:
      "5119 - Venda de mercadoria adquirida ou recebida de terceiros, entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem",
    value: "5119",
  },
  {
    label:
      "5120 - Venda de mercadoria adquirida ou recebida de terceiros, entregue ao destinatário pelo vendedor remetente, em venda à ordem",
    value: "5120",
  },
  {
    label:
      "5122 - Venda de produção do estabelecimento remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente",
    value: "5122",
  },
  {
    label:
      "5123 - Venda de mercadoria adquirida ou recebida de terceiros, remetida para industrialização por conta e ordem do adquirente, sem transitar pelo estabelecimento adquirente",
    value: "5123",
  },

  // COMPRAS DENTRO DO ESTADO (5.000)
  {
    label: "5401 - Compra para industrialização ou produção rural",
    value: "5401",
  },
  { label: "5402 - Compra para comercialização", value: "5402" },
  {
    label: "5403 - Compra para industrialização sob regime de drawback",
    value: "5403",
  },
  {
    label:
      "5405 - Compra de mercadoria para ser utilizada na prestação de serviço sujeita ao ICMS",
    value: "5405",
  },
  {
    label:
      "5408 - Compra para industrialização em operação com mercadoria sujeita ao regime de substituição tributária",
    value: "5408",
  },
  {
    label:
      "5409 - Compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
    value: "5409",
  },
  {
    label:
      "5410 - Compra para utilização na prestação de serviço sujeita ao ICMS, em operação com mercadoria sujeita ao regime de substituição tributária",
    value: "5410",
  },

  // TRANSFERÊNCIAS DENTRO DO ESTADO (5.000)
  {
    label: "5151 - Transferência de produção do estabelecimento",
    value: "5151",
  },
  {
    label:
      "5152 - Transferência de mercadoria adquirida ou recebida de terceiros",
    value: "5152",
  },
  { label: "5153 - Transferência de energia elétrica", value: "5153" },
  {
    label:
      "5155 - Transferência de produção do estabelecimento, que não deva por ele transitar",
    value: "5155",
  },
  {
    label:
      "5156 - Transferência de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar",
    value: "5156",
  },

  // SERVIÇOS DENTRO DO ESTADO (5.000)
  { label: "5551 - Venda de ativo imobilizado", value: "5551" },
  { label: "5552 - Transferência de ativo imobilizado", value: "5552" },

  // VENDAS PARA OUTROS ESTADOS (6.000)
  { label: "6101 - Venda de produção do estabelecimento", value: "6101" },
  {
    label: "6102 - Venda de mercadoria adquirida ou recebida de terceiros",
    value: "6102",
  },
  {
    label:
      "6103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento",
    value: "6103",
  },
  {
    label:
      "6104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento",
    value: "6104",
  },
  {
    label:
      "6107 - Venda de produção do estabelecimento, operação com produto sujeito à tributação monofásica",
    value: "6107",
  },
  {
    label:
      "6108 - Venda de mercadoria adquirida ou recebida de terceiros, operação com produto sujeito à tributação monofásica",
    value: "6108",
  },
  {
    label:
      "6109 - Venda de produção do estabelecimento, não tributada pelo ICMS",
    value: "6109",
  },
  {
    label:
      "6110 - Venda de mercadoria adquirida ou recebida de terceiros, não tributada pelo ICMS",
    value: "6110",
  },
  {
    label:
      "6111 - Venda de produção do estabelecimento remetida anteriormente em consignação industrial",
    value: "6111",
  },
  {
    label:
      "6112 - Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação industrial",
    value: "6112",
  },
  {
    label:
      "6113 - Venda de produção do estabelecimento remetida anteriormente em consignação mercantil",
    value: "6113",
  },
  {
    label:
      "6114 - Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação mercantil",
    value: "6114",
  },
  {
    label:
      "6115 - Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil",
    value: "6115",
  },
  {
    label:
      "6116 - Venda de produção do estabelecimento originada de encomenda para entrega futura",
    value: "6116",
  },
  {
    label:
      "6117 - Venda de mercadoria adquirida ou recebida de terceiros, originada de encomenda para entrega futura",
    value: "6117",
  },
  {
    label:
      "6118 - Venda de produção do estabelecimento entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem",
    value: "6118",
  },
  {
    label:
      "6119 - Venda de mercadoria adquirida ou recebida de terceiros, entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem",
    value: "6119",
  },
  {
    label:
      "6120 - Venda de mercadoria adquirida ou recebida de terceiros, entregue ao destinatário pelo vendedor remetente, em venda à ordem",
    value: "6120",
  },

  // COMPRAS DE OUTROS ESTADOS (6.000)
  {
    label: "6401 - Compra para industrialização ou produção rural",
    value: "6401",
  },
  { label: "6402 - Compra para comercialização", value: "6402" },
  {
    label: "6403 - Compra para industrialização sob o regime de drawback",
    value: "6403",
  },
  {
    label:
      "6404 - Compra de mercadoria sujeita ao regime de substituição tributária",
    value: "6404",
  },
  {
    label:
      "6408 - Compra para industrialização em operação com mercadoria sujeita ao regime de substituição tributária",
    value: "6408",
  },
  {
    label:
      "6409 - Compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
    value: "6409",
  },
  {
    label:
      "6410 - Compra para utilização na prestação de serviço sujeita ao ICMS, em operação com mercadoria sujeita ao regime de substituição tributária",
    value: "6410",
  },
  {
    label:
      "6411 - Compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime de antecipação do recolhimento do imposto",
    value: "6411",
  },
  {
    label:
      "6412 - Compra para comercialização em operação com mercadoria sujeita ao regime de antecipação do recolhimento do imposto",
    value: "6412",
  },

  // TRANSFERÊNCIAS PARA OUTROS ESTADOS (6.000)
  {
    label: "6151 - Transferência de produção do estabelecimento",
    value: "6151",
  },
  {
    label:
      "6152 - Transferência de mercadoria adquirida ou recebida de terceiros",
    value: "6152",
  },
  {
    label: "6153 - Transferência de energia elétrica para distribuição",
    value: "6153",
  },
  {
    label:
      "6155 - Transferência de produção do estabelecimento, que não deva por ele transitar",
    value: "6155",
  },
  {
    label:
      "6156 - Transferência de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar",
    value: "6156",
  },

  // VENDAS PARA O EXTERIOR (7.000)
  { label: "7101 - Venda de produção do estabelecimento", value: "7101" },
  {
    label: "7102 - Venda de mercadoria adquirida ou recebida de terceiros",
    value: "7102",
  },
  {
    label:
      "7105 - Venda de produção do estabelecimento, que não deva por ele transitar",
    value: "7105",
  },
  {
    label:
      "7106 - Venda de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar",
    value: "7106",
  },
  {
    label:
      "7127 - Venda de produção do estabelecimento sob o regime de drawback",
    value: "7127",
  },

  // IMPORTAÇÕES (3.000)
  {
    label: "3101 - Compra para industrialização ou produção rural",
    value: "3101",
  },
  { label: "3102 - Compra para comercialização", value: "3102" },
  {
    label:
      "3126 - Compra para utilização na prestação de serviço sujeita ao ICMS",
    value: "3126",
  },
  {
    label: "3127 - Compra para industrialização sob o regime de drawback",
    value: "3127",
  },
  {
    label:
      "3128 - Compra para utilização na prestação de serviço sujeita ao ICMS, sob o regime de drawback",
    value: "3128",
  },

  // DEVOLUÇÃO DE VENDAS (1.000)
  {
    label: "1201 - Devolução de venda de produção do estabelecimento",
    value: "1201",
  },
  {
    label:
      "1202 - Devolução de venda de mercadoria adquirida ou recebida de terceiros",
    value: "1202",
  },
  {
    label:
      "1203 - Devolução de venda de produção do estabelecimento, efetuada fora do estabelecimento",
    value: "1203",
  },
  {
    label:
      "1204 - Devolução de venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento",
    value: "1204",
  },
  {
    label:
      "1208 - Devolução de produção do estabelecimento, remetida em transferência",
    value: "1208",
  },
  {
    label:
      "1209 - Devolução de mercadoria adquirida ou recebida de terceiros, remetida em transferência",
    value: "1209",
  },
  {
    label:
      "1410 - Retorno de produção do estabelecimento, remetida para venda fora do estabelecimento",
    value: "1410",
  },
  {
    label:
      "1411 - Retorno de mercadoria adquirida ou recebida de terceiros, remetida para venda fora do estabelecimento",
    value: "1411",
  },

  // ENTRADAS DE MERCADORIAS SUJEITAS AO REGIME DE SUBSTITUIÇÃO TRIBUTÁRIA (1.000)
  {
    label:
      "1403 - Compra para industrialização em operação com mercadoria sujeita ao regime de substituição tributária",
    value: "1403",
  },
  {
    label:
      "1406 - Compra de mercadoria para ser utilizada na prestação de serviço sujeita ao ICMS",
    value: "1406",
  },
  {
    label:
      "1407 - Compra de mercadoria para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
    value: "1407",
  },

  // ESPECÍFICOS PARA RESTAURANTES E DELIVERY
  {
    label:
      "5405 - Venda de mercadoria adquirida para ser utilizada na prestação de serviço",
    value: "5405",
  },
  {
    label:
      "6405 - Venda de mercadoria adquirida para ser utilizada na prestação de serviço (outros estados)",
    value: "6405",
  },
  {
    label:
      "5926 - Lançamento efetuado a título de simples faturamento decorrente de venda para entrega futura",
    value: "5926",
  },
  {
    label:
      "6926 - Lançamento efetuado a título de simples faturamento decorrente de venda para entrega futura (outros estados)",
    value: "6926",
  },

  // OUTROS CÓDIGOS RELEVANTES
  {
    label:
      "5949 - Outra saída de mercadoria ou prestação de serviço não especificado",
    value: "5949",
  },
  {
    label:
      "6949 - Outra saída de mercadoria ou prestação de serviço não especificado (outros estados)",
    value: "6949",
  },
  {
    label:
      "1949 - Outra entrada de mercadoria ou prestação de serviço não especificado",
    value: "1949",
  },
  {
    label:
      "2949 - Outra entrada de mercadoria ou prestação de serviço não especificado (outros estados)",
    value: "2949",
  },
  {
    label:
      "3949 - Outra entrada de mercadoria ou prestação de serviço não especificado (exterior)",
    value: "3949",
  },

  // ENERGIA ELÉTRICA E COMUNICAÇÃO
  {
    label:
      "5301 - Prestação de serviço de comunicação para execução de serviço da mesma natureza",
    value: "5301",
  },
  {
    label:
      "5302 - Prestação de serviço de comunicação a estabelecimento industrial",
    value: "5302",
  },
  {
    label:
      "5303 - Prestação de serviço de comunicação a estabelecimento comercial",
    value: "5303",
  },
  {
    label:
      "5304 - Prestação de serviço de comunicação a estabelecimento de prestador de serviço de comunicação",
    value: "5304",
  },
  {
    label:
      "5305 - Prestação de serviço de comunicação a estabelecimento de geradora ou de distribuidora de energia elétrica",
    value: "5305",
  },
  {
    label:
      "5306 - Prestação de serviço de comunicação a estabelecimento de produtor rural",
    value: "5306",
  },
  {
    label: "5307 - Prestação de serviço de comunicação a não contribuinte",
    value: "5307",
  },
];

export const icms_situacao_tributaria_frame = [
  {
    label: "Tributada pelo Simples Nacional sem permissão de crédito",
    value: "102",
  },
  {
    label: "Tributada pelo Simples Nacional com permissão de crédito",
    value: "101",
  },
  {
    label: "Isenção do ICMS no Simples Nacional para faixa de receita bruta",
    value: "103",
  },
  { label: "Imune", value: "300" },
  { label: "Não tributada pelo Simples Nacional", value: "400" },
  {
    label:
      " ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação",
    value: "500",
  },
  { label: "Outros", value: "900" },
];

export const icms_origem_frame = [
  { label: "Nacional", value: "0" },
  { label: "Estrangeira (importação direta)", value: "1" },
  { label: "Estrangeira (adquirida no mercado interno)", value: "2" },
  { label: "Nacional com mais de 40% de conteúdo estrangeiro", value: "3" },
  {
    label: "Nacional produzida através de processos produtivos básicos",
    value: "4",
  },
  { label: "Nacional com menos de 40% de conteúdo estrangeiro", value: "5" },
  {
    label: "Estrangeira (importação direta) sem produto nacional similar",
    value: "6",
  },
  {
    label:
      "Estrangeira (adquirida no mercado interno) sem produto nacional similar",
    value: "7",
  },
];

export const cofins_situacao_tributaria_frame = [
  { label: "Outras operações de saída", value: "49" },
  {
    label:
      "Operação tributável: base de cálculo = valor da operação (alíquota normal – cumulativo/não cumulativo)",
    value: "01",
  },
  {
    label:
      "Operação tributável: base de cálculo = valor da operação (alíquota diferenciada)",
    value: "02",
  },
  {
    label:
      "Operação tributável: base de cálculo = quantidade vendida × alíquota por unidade de produto",
    value: "03",
  },
  {
    label: "Operação tributável: tributação monofásica (alíquota zero)",
    value: "04",
  },
  { label: "Operação tributável: substituição tributária", value: "05" },
  { label: "Operação tributável: alíquota zero", value: "06" },
  { label: "Operação isenta da contribuição", value: "07" },
  { label: "Operação sem incidência da contribuição", value: "08" },
  { label: "Operação com suspensão da contribuição", value: "09" },
  {
    label:
      "Operação com direito a crédito: vinculada exclusivamente a receita tributada no mercado interno",
    value: "50",
  },
  {
    label:
      "Operação com direito a crédito: vinculada exclusivamente a receita não tributada no mercado interno",
    value: "51",
  },
  {
    label:
      "Operação com direito a crédito: vinculada exclusivamente a receita de exportação",
    value: "52",
  },
  {
    label:
      "Operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno",
    value: "53",
  },
  {
    label:
      "Operação com direito a crédito: vinculada a receitas tributadas no mercado interno e de exportação",
    value: "54",
  },
  {
    label:
      "Operação com direito a crédito: vinculada a receitas não-tributadas no mercado interno e de exportação",
    value: "55",
  },
  {
    label:
      "Operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação",
    value: "56",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada exclusivamente a receita tributada no mercado interno",
    value: "60",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada exclusivamente a receita não-tributada no mercado interno",
    value: "61",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada exclusivamente a receita de exportação",
    value: "62",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno",
    value: "63",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada a receitas tributadas no mercado interno e de exportação",
    value: "64",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada a receitas não-tributadas no mercado interno e de exportação",
    value: "65",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação",
    value: "66",
  },
  { label: "Crédito presumido: outras operações", value: "67" },
  { label: "Operação de aquisição sem direito a crédito", value: "70" },
  { label: "Operação de aquisição com isenção", value: "71" },
  { label: "Operação de aquisição com suspensão", value: "72" },
  { label: "Operação de aquisição a alíquota zero", value: "73" },
  {
    label: "Operação de aquisição sem incidência da contribuição",
    value: "74",
  },
  { label: "Operação de aquisição por substituição tributária", value: "75" },
  { label: "Outras operações de entrada", value: "98" },
  { label: "Outras operações", value: "99" },
];

export const pis_situacao_tributaria_frame = [
  { label: "Outras operações de saída", value: "49" },
  {
    label:
      "Operação tributável: base de cálculo = valor da operação (alíquota normal – cumulativo/não cumulativo)",
    value: "01",
  },
  {
    label:
      "Operação tributável: base de cálculo = valor da operação (alíquota diferenciada)",
    value: "02",
  },
  {
    label:
      "Operação tributável: base de cálculo = quantidade vendida × alíquota por unidade de produto",
    value: "03",
  },
  {
    label: "Operação tributável: tributação monofásica (alíquota zero)",
    value: "04",
  },
  { label: "Operação tributável: substituição tributária", value: "05" },
  { label: "Operação tributável: alíquota zero", value: "06" },
  { label: "Operação isenta da contribuição", value: "07" },
  { label: "Operação sem incidência da contribuição", value: "08" },
  { label: "Operação com suspensão da contribuição", value: "09" },
  {
    label:
      "Operação com direito a crédito: vinculada exclusivamente a receita tributada no mercado interno",
    value: "50",
  },
  {
    label:
      "Operação com direito a crédito: vinculada exclusivamente a receita não tributada no mercado interno",
    value: "51",
  },
  {
    label:
      "Operação com direito a crédito: vinculada exclusivamente a receita de exportação",
    value: "52",
  },
  {
    label:
      "Operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno",
    value: "53",
  },
  {
    label:
      "Operação com direito a crédito: vinculada a receitas tributadas no mercado interno e de exportação",
    value: "54",
  },
  {
    label:
      "Operação com direito a crédito: vinculada a receitas não-tributadas no mercado interno e de exportação",
    value: "55",
  },
  {
    label:
      "Operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação",
    value: "56",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada exclusivamente a receita tributada no mercado interno",
    value: "60",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada exclusivamente a receita não-tributada no mercado interno",
    value: "61",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada exclusivamente a receita de exportação",
    value: "62",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno",
    value: "63",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada a receitas tributadas no mercado interno e de exportação",
    value: "64",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada a receitas não-tributadas no mercado interno e de exportação",
    value: "65",
  },
  {
    label:
      "Crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação",
    value: "66",
  },
  { label: "Crédito presumido: outras operações", value: "67" },
  { label: "Operação de aquisição sem direito a crédito", value: "70" },
  { label: "Operação de aquisição com isenção", value: "71" },
  { label: "Operação de aquisição com suspensão", value: "72" },
  { label: "Operação de aquisição a alíquota zero", value: "73" },
  {
    label: "Operação de aquisição sem incidência da contribuição",
    value: "74",
  },
  { label: "Operação de aquisição por substituição tributária", value: "75" },
  { label: "Outras operações de entrada", value: "98" },
  { label: "Outras operações", value: "99" },
];

export const fiscalCodeRegistered = [
  {
    label: "Todos",
    value: "ALL",
  },
  {
    label: "Cadastrado",
    value: 1,
  },
  {
    label: "Não Cadastrado",
    value: 0,
  },
];

export const customerBlacklisted = [
  {
    label: "Todos",
    value: "ALL",
  },
  {
    label: "Sim",
    value: true,
  },
  {
    label: "Não",
    value: false,
  },
];
